// extracted by mini-css-extract-plugin
export var highlightFade = "_2a-4";
export var highlighted = "_2a-3";
export var table = "_2a-1";
export var tableContainer = "_2a-0";
export var totalsRow = "_2a-2";